module.exports = __webpack_public_path__ + "static/media/Tile 1.27e68c5c.jpg";